<template>
<div class="fc-page mg-page mg-employee_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>员工管理</h1><p>管理老师与员工资料、所属校区及账号角色</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">添加老师</v-btn></div></header><section class="fc-filters" aria-label="员工管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectShopList" v-model="query.shopId" item-text="shopName"
								item-value="id" label="校区" dense outlined clearable color="#d9363e" aria-label="校区"></v-select></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="员工号" outlined v-model="query.employeeNo" color="#d9363e" aria-label="员工号">
							</v-text-field></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="员工姓名" outlined v-model="query.employeeName" color="#d9363e" aria-label="员工姓名">
							</v-text-field></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="员工列表"><div class="fc-list-heading"><h3>员工列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<!-- <v-chip small :color="employeeStatusColor(item.status)">{{ employeeStatusName(item.status) }}
				</v-chip> -->
				{{ employeeStatusName(item.status) }}
			</template>
			<template v-slot:item.canLogin="{item}">
				<v-chip small :color="canLoginColor(item.canLogin)">{{ canLoginName(item.canLogin) }}
				</v-chip>
			</template>
			<template v-slot:item.roleNames="{item}">
				<span v-for="(item,index) in item.roleNames" :key="index" class="mr-1">{{ item }}</span>
				<!-- <v-chip v-for="(item,index) in item.roleNames" :key="index" small color="info" class="mr-3">
					{{ item }}
				</v-chip> -->
			</template>
			<template v-slot:item.shopNameList="{item}">
				<span v-if="item.shopNameList && item.shopNameList[0]" >{{item.shopNameList[0]}}</span>

				<v-btn color="warning" x-small @click="showShopList(item)" class="ml-3"
					v-if="item.shopNameList && item.shopNameList[0] && item.shopNameList[1]" depressed>
					更多
				</v-btn>
			</template>
			<template v-slot:item.avatar="{item}">
				<v-avatar rounded class="my-1">
					<v-img v-if="item.avatar" :src="imgPrev + item.avatar + imgSize50" width="50" height="50"></v-img>
				</v-avatar>
			</template>
			<template v-slot:item.isTeacher="{item}">
				{{item.isTeacher === '1'?'是':'否'}}
			</template>
			<template v-slot:item.isBindWx="{item}">
				<!-- <v-chip small :color="item.isBindWx === '1'?'success':'error'" >{{item.isBindWx === '1'?'已绑定':'未绑定'}}</v-chip> -->

				<span v-if="item.isBindWx=='1'">已绑定</span>
				<span v-else style="color:red">未绑定</span>
			</template>

			<template v-slot:item.action="{item}">
				<v-menu top>
					<template v-slot:activator="{ attrs, on }">
						<v-btn color="#d9363e" v-bind="attrs" v-on="on" small depressed>
							操作
						</v-btn>
					</template>
					<v-list color="white" class="align-center fc-action-menu">
						<v-list-item class="justify-center fc-action-menu">
							<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改资料</v-btn>
						</v-list-item>
						<v-list-item class="justify-center fc-action-menu" v-if="item.status==='1'">
							<v-btn @click="frozenEmployee(item)"  color="error" small depressed>冻结帐号</v-btn>
						</v-list-item>
						<v-list-item class="justify-center fc-action-menu" v-if="item.status !=='1'">
							<v-btn @click="freeEmployee(item)" color="#d9363e" small depressed>解冻帐号</v-btn>
						</v-list-item>
						<v-list-item class="justify-center fc-action-menu">
							<v-btn @click.stop="showResetPwd(item)" color="warning" small depressed>重置密码</v-btn>
						</v-list-item>
						<v-list-item class="justify-center fc-action-menu">
							<v-btn @click.stop="showSetRole(item)" color="#d9363e" small depressed>分配角色</v-btn>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog v-model="shopDialog.dialog" scrollable max-width="460">

		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2>校区列表</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭校区列表" @click="shopDialog.dialog = false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-chip v-for="(item,index) in shopDialog.shopNameList" :key="index" small color="info" class="mr-3">
					{{ item }}
				</v-chip>
			</v-card-text>

			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text @click="shopDialog.dialog = false" depressed>
					关闭
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="修改员工信息" v-model="update.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2>修改员工信息</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改员工信息" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-text-field label="昵称" v-model="update.employee.nickName" dense outlined color="#d9363e" aria-label="昵称"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="姓名" v-model="update.employee.trueName" dense outlined color="#d9363e" aria-label="姓名"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="手机号" v-model="update.employee.mobile" dense outlined color="#d9363e" aria-label="手机号"></v-text-field>
					</v-col>
					<v-col cols="12">
						<!-- 上传图片组件 -->
						<!-- <uploadPhoto :show="update.dialog" :previewImg="update.employee.avatar" @success="uploadSuccess"></uploadPhoto> -->
						<!-- 上传图片组件 -->
						<cutImageUpload :show="update.dialog" title="修改老师头像" :previewImg="update.employee.avatar"  @success="uploadSuccess"></cutImageUpload>
					</v-col>

					<v-col cols="12" class="mt-4">
						<v-select v-model="update.employee.shopIdList" :items="selectShopList" label="员工校区" multiple
							item-text="shopName" item-value="id" outlined dense color="#d9363e" aria-label="员工校区"></v-select>
					</v-col>
					<v-col cols="4">
						<v-switch v-model="update.employee.isTeacher" class="mt-0" color="green lighten-2"
							hide-details label="是否代课"></v-switch>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateEmployee" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="重置密码" v-model="resetpwd.dialog" max-width="600" persistent scrollable>


		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2>重置密码</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭重置密码" @click="resetpwd.dialog = false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-text-field label="员工姓名" v-model="resetpwd.trueName" disabled dense outlined color="#d9363e" aria-label="员工姓名">
						</v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="请输入新密码" type="password" v-model="resetpwd.newPwd" dense outlined color="#d9363e" aria-label="请输入新密码">
						</v-text-field>
					</v-col>
				</v-row>

			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="resetpwd.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitResetPwd" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="分配角色" v-model="setRole.dialog" max-width="600" persistent scrollable>


		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2>分配角色</h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭分配角色" @click="setRole.dialog = false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12" class="d-flex">
						<v-checkbox v-if="setRole.roleList" v-for="(item,index) in setRole.roleList"
							:key="item.roleId" true-value="1" false-value="0" v-model="item.hasRole"
							:label="item.roleName" class="mr-3">
						</v-checkbox>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="setRole.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitSetRole" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<createTeacher :show="add.dialog" @cancel="add.dialog=false" @success="teacherCreated"></createTeacher></div>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import md5 from "js-md5"
	import createTeacher from "../../../components/create_teacher.vue"
	
	import cutImageUpload from "../../../components/cut_image_upload.vue"
	export default {
		name: "employee-list",
		components:{createTeacher,cutImageUpload},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				shopDialog:false,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '员工管理',
						disabled: true
					},
				],
				shopId:"",
				imgPrev: global.config.imgPre,
				imgSize50:global.config.imgSize50,
				data: {
					total: 0,
					headers: [{
							text: '员工号',
							value: 'employeeNo',
							sortable: false
						},
						{
							text: '昵称',
							value: 'nickName',
							sortable: false
						},
						{
							text: '姓名',
							value: 'trueName',
							sortable: false
						},
						{
							text: '头像',
							value: 'avatar',
							sortable: false
						},
						{
							text: '手机号',
							value: 'mobile',
							sortable: false
						},
						
						{
							text: '拥有角色',
							value: 'roleNames',
							sortable: false
						},
						{
							text: '所属门店',
							value: 'shopNameList',
							sortable: false
						},
						{
							text: '是否代课',
							value: 'isTeacher',
							sortable: false
						},
						{
							text: '绑定微信',
							value: 'isBindWx',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				selectShopList: [], // 校区
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					employeeName: "",
					employeeNo: "",
					shopId:"",
				},
				
				add: {
					dialog: false,
				},
				update: {
					dialog: false,
					employee: {
						employeeId: "",
						nickName: "",
						trueName: "",
						avatar: "",
						mobile: "",
						canLogin: false,
						shopIdList: "",
						isTeacher:false,
					}
				},
				resetpwd: {
					dialog: false,
					employeeId: "",
					trueName: "",
					newPwd: "",
				},
				setRole: {
					dialog: false,
					employeeId: "",
					roleList: [],
					checkedRoleIds: []
				},
				shopDialog:{
					dialog: false,
					shopNameList:[]
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.query.shopId = this.shopId;
			this.getEmployeeList();
			// 加载校区列表
			this.getShopListForSelect();

		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getEmployeeList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getEmployeeList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getEmployeeList();
			},
			teacherCreated(){
				this.add.dialog = false;
				this.getEmployeeList();
			},
			uploadSuccess(e){
				this.update.employee.avatar = e.key;
			},
			
			showAddDialog() {
				this.add.dialog = true;

			},
			getEmployeeList() {
				const that = this;
				this.query.loading = true;


				let url = `/sys/employee/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.employeeName) {
					url += "&employeeName=" + this.query.employeeName;
				}
				if (this.query.employeeNo) {
					url += "&employeeNo=" + this.query.employeeNo;
				}
				if (this.query.shopId) {
					url += "&shopId=" + this.query.shopId;
				}


				this.axios.get(url).then(response => {

					console.log(response);

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			canLoginColor(state) {

				let stName = "";
				if (state === "1") {
					stName = "success";
				} else if (state === "0") {
					stName = "error";
				}
				return stName;
			},
			canLoginName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "允许登录";
				} else if (state === "0") {
					stName = "不能登录";
				}
				return stName;
			},
			employeeStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			employeeStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			frozenEmployee(item) {
				//冻结
				const that = this;
				let url = `/sys/employee/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("冻结成功");
							that.getEmployeeList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			freeEmployee(item) {
				//解冻
				const that = this;
				let url = `/sys/employee/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("解冻成功");
							that.getEmployeeList();
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}

				});
			},
			showUpdate(item) {
				this.update.dialog = true;
				this.update.employee.employeeId = item.id;
				this.update.employee.trueName = item.trueName;
				this.update.employee.nickName = item.nickName;
				this.update.employee.avatar = item.avatar;
				this.update.employee.mobile = item.mobile;
				this.update.employee.canLogin = item.canLogin == "1" ? true : false;
				this.update.employee.shopIdList = item.shopIdList;
				this.update.employee.isTeacher = item.isTeacher == "1" ? true : false;

				// this.clearUpload();
				// this.upload.key = item.avatar;
			},
			submitUpdateEmployee() {

				if (!this.update.employee.nickName) {
					this.$noty.error('昵称不能为空');
					return
				}
				if (!this.update.employee.trueName) {
					this.$noty.error('姓名不能为空');
					return
				}

				// api
				const that = this;
				let url = `/sys/employee/update`;

				// parameters
				let canLoginValue = "0";
				if (this.update.employee.canLogin == true) {
					canLoginValue = "1";
				}
				
				const updateData = {
					employeeId: this.update.employee.employeeId,
					trueName: this.update.employee.trueName,
					nickName: this.update.employee.nickName,
					mobile: this.update.employee.mobile,
					canLogin: canLoginValue,
					avatar: this.update.employee.avatar,
					shopIdList: this.update.employee.shopIdList,
					isTeacher:this.update.employee.isTeacher?"1":"0",
					
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getEmployeeList();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showResetPwd(item) {
				this.resetpwd.dialog = true;
				this.resetpwd.employeeId = item.id;
				this.resetpwd.trueName = item.trueName;
			},
			submitResetPwd() {

				if (!this.resetpwd.newPwd) {
					this.$noty.error('请输入新密码');
					return
				}

				// api
				const that = this;
				let url = `/sys/employee/password/reset`;
				let postData = {
					employeeId: this.resetpwd.employeeId,
					newPwd: md5(this.resetpwd.newPwd)
				};
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getEmployeeList();
							that.resetpwd.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showSetRole(item) {
				this.setRole.dialog = true;
				this.setRole.employeeId = item.id;

				// 获取员工的角色列表
				this.setRole.checkedRoleIds = [];
				this.getEmployeeRoleList();

			},
			getEmployeeRoleList() {
				const that = this;
				let url = `/sys/employee/role/list/` + this.setRole.employeeId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.setRole.roleList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			submitSetRole() {
				// 处理选中的角色ID 
				this.setRole.checkedRoleIds = [];
				if (this.setRole.roleList) {
					this.setRole.roleList.forEach((item, index) => {
						if (item.hasRole == '1') {
							this.setRole.checkedRoleIds.push(item.roleId);
						}
					})
				}
				console.log(this.setRole.checkedRoleIds);

				// api
				const that = this;
				let url = `/sys/employee/role/save`;


				const updateData = {
					employeeId: this.setRole.employeeId,
					roleIds: this.setRole.checkedRoleIds,
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");

							that.setRole.dialog = false;
							that.getEmployeeList();

							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			showShopList(item){
				this.shopDialog.dialog = true;
				this.shopDialog.shopNameList = item.shopNameList;
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
